import React, { useEffect, useState } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import Navigation from '../components/Navigation';
import { apiGet } from '../utils/api';
import { useAuth } from '../contexts/AuthContext';
import { Crown, ScanText, MessageCircle } from '../components/Icons';
import InvoiceParsingPro from './InvoiceParsingPro';
import WhatsAppInvoicesPro from './WhatsAppInvoicesPro';

const WHATSAPP_NUMBER = '923219630757';

// Each tab has its own URL, so a feature can be linked to directly and the old
// /pro/invoice-parsing link keeps working. Add a new Pro feature by adding a row.
const FEATURES = [
  { slug: 'whatsapp-invoices', label: 'Automatic WhatsApp Invoices', icon: MessageCircle, component: WhatsAppInvoicesPro },
  { slug: 'invoice-parsing', label: 'Invoice Parsing', icon: ScanText, component: InvoiceParsingPro },
];

const ProFeatures = () => {
  const { feature } = useParams();
  const { user } = useAuth();
  const [tenant, setTenant] = useState(null);

  useEffect(() => {
    if (!user?.tenant_id) return;
    apiGet('/api/tenant/profile').then((response) => {
      if (response.ok) setTenant(response.data.tenant || response.data);
    }).catch(() => {});
  }, [user?.tenant_id]);

  const active = FEATURES.find((f) => f.slug === feature);
  if (!active) return <Navigate to={`/pro/${FEATURES[0].slug}`} replace />;

  const businessName = tenant?.name || '';
  const whatsappLink = (featureName) => `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    `Hi, I'm interested in the ${featureName} for ${businessName || 'my business'} on AxiomSquare.`
  )}`;
  const Content = active.component;

  return (
    <Navigation>
      <div className="min-h-screen bg-gray-50">
        <div className="bg-white shadow">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="pt-6 pb-4">
              <h1 className="flex items-center gap-2 text-2xl font-bold text-gray-900">
                <Crown className="h-6 w-6 text-amber-600" />
                Pro Features
              </h1>
              <p className="mt-1 text-gray-600">Add ons that save your team hours every month.</p>
            </div>
            <nav className="-mb-px flex gap-2 overflow-x-auto" aria-label="Pro features">
              {FEATURES.map((f) => {
                const isActive = f.slug === active.slug;
                return (
                  <Link
                    key={f.slug}
                    to={`/pro/${f.slug}`}
                    className={`flex items-center gap-2 whitespace-nowrap border-b-2 px-3 py-3 text-sm font-medium transition-colors ${
                      isActive
                        ? 'border-amber-600 text-amber-700'
                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                    }`}
                    aria-current={isActive ? 'page' : undefined}
                  >
                    <f.icon className="h-4 w-4" />
                    {f.label}
                  </Link>
                );
              })}
            </nav>
          </div>
        </div>

        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <Content whatsappLink={whatsappLink} businessName={businessName} />
        </div>
      </div>
    </Navigation>
  );
};

export default ProFeatures;
